export const Endpoint = "users/get-self";
export const Method = "GET";
